export default "__VITE_ASSET__Ckapwc6j__"